// Static UI translations used outside the CMS (buttons, labels, alt text, etc.)
// Keys should be stable. Add new keys here as we localize more pages.

export const TRANSLATIONS = {
 ar: {
 // Navbar
 "nav.home": "الرئيسية",
 "nav.services": "الخدمات",
 "nav.spaces": "المساحات",
 "nav.business": "خدمات الأعمال",
 "nav.pod": "البود الذكي",
 "nav.about": "من نحن",
 "nav.contact": "تواصل معنا",
 "nav.cta": "احجز جولتك المجانية",
 "lang.toggle.aria": "تبديل اللغة",
 "lang.short": "EN",

 // HomePage extras
 "home.discover_more": "اكتشف المزيد",
 "home.gallery_image_alt": "مساحة",
 "home.bg.about": "من نحن",
 "home.bg.services": "خدماتنا",
 "home.bg.why": "لماذا كن",
 "home.bg.audience": "عملاؤنا",
 "home.bg.gallery": "مساحاتنا",
 "home.bg.contact": "تواصل معنا",

 // Footer
 "footer.quick_links": "روابط سريعة",
 "footer.contact_us": "تواصل معنا",
 "footer.location": "المملكة العربية السعودية، الرياض",
 "footer.brand_description":
 "رائدون في توفير مساحات العمل المشتركة في الرياض. نقدم بيئة عمل احترافية وتعاونية لتحقيق أهدافك.",
 "footer.rights": "© KUN - جميع الحقوق محفوظة",

 // Generic
 "common.discover_more": "اكتشف المزيد",
 "common.contact_us": "تواصل معنا",
 "common.book_now": "احجز الآن",
 "common.send": "إرسال",
 "common.sending": "جاري الإرسال...",
 "common.loading": "جاري التحميل...",
 "common.persons": "أشخاص",
 "common.selected": "محدد",
 "common.try_again": "حدث خطأ، يرجى المحاولة مرة أخرى",

 // Spaces page
 "spaces.shared_desks_title": "المكاتب المشتركة",
 "spaces.private_offices_title": "المكاتب الخاصة",
 "spaces.meeting_rooms_title": "قاعات الاجتماعات",
 "spaces.available_seats": "المقاعد المتاحة",
 "spaces.occupied_seats": "المقاعد المحجوزة",
 "spaces.shared_desks_alt": "المكاتب المشتركة",
 "spaces.book_shared_desk": "احجز مكتبك المشترك",
 "spaces.book_office_btn": "احجز هذا المكتب",
 "spaces.book_meeting_btn": "احجز القاعة",
 "spaces.reserved_label": "محجوز",
 "spaces.available_now": "متاح الآن",
 "spaces.reserved_until": "محجوز حتى",
 "spaces.price_start_badge": "يبدأ من",
 "spaces.price_per_month": "/ شهرياً",
 "spaces.price_currency": "ريال",
 "spaces.shared_desks_price": "1,500",
 "spaces.private_offices_price": "3,500",
 "spaces.what_you_get_eyebrow": "ما الذي تحصل عليه",
 "spaces.what_you_get_title": "كل ما تحتاجه لإنتاجية بلا حدود",
 "spaces.shared_feat_1": "مكتب مشترك (Hot Desk)",
 "spaces.shared_feat_2": "إنترنت فائق السرعة غير محدود",
 "spaces.shared_feat_3": "ضيافة غير محدودة (قهوة، شاي، مياه)",
 "spaces.shared_feat_4": "طباعة غير محدودة",
 "spaces.shared_feat_5": "وصول مرن بالساعة أو اليوم",
 "spaces.shared_feat_6": "استخدام المناطق المشتركة",
 "spaces.private_feat_1": "مكتب خاص مجهز بالكامل",
 "spaces.private_feat_2": "إنترنت فائق السرعة غير محدود",
 "spaces.private_feat_3": "ضيافة غير محدودة (قهوة، شاي، مياه)",
 "spaces.private_feat_4": "طباعة غير محدودة",
 "spaces.private_feat_5": "عنوان تجاري رسمي",
 "spaces.private_feat_6": "خدمة استقبال وسكرتارية",
 "spaces.private_feat_7": "قاعات اجتماعات (ساعات شهرية)",
 "spaces.private_feat_8": "دعم إداري وتشغيلي متكامل",
 "spaces.pick_date_time": "اختر التاريخ والوقت",
 "spaces.available_times": "الأوقات المتاحة",
 "spaces.empty_state": "اختر قاعة اجتماعات للبدء",
 "spaces.slot_booked": "محجوز",
 "spaces.slot_blocked": "مغلق",
 "spaces.gallery_count": "صور",
 "spaces.gallery_open_aria": "عرض كل الصور",
 "spaces.gallery_prev_aria": "السابق",
 "spaces.gallery_next_aria": "التالي",
 "spaces.gallery_dialog_desc": "معرض صور",
 "spaces.eyebrow": "المساحات",
 "spaces.title": "مساحات عمل تناسب طموحك",
 "spaces.subtitle": "اختر المساحة المثالية لأعمالك من بين خيارات متنوعة ومرنة",

 // Booking dialog
 "book.dialog_title": "طلب حجز",
 "book.dialog_description": "يرجى تعبئة بياناتك وسنقوم بالتواصل معكم قريباً",
 "book.full_name": "الاسم الكامل",
 "book.phone": "رقم الهاتف",
 "book.email": "البريد الإلكتروني",
 "book.helper": "سيتم التواصل معكم لتأكيد الحجز",
 "book.submit": "إرسال طلب",
 "book.fill_all_fields": "يرجى تعبئة جميع الحقول",

 // Business page
 "business.eyebrow": "خدمات الأعمال",
 "business.title": "خدمات أعمال متكاملة",
 "business.subtitle": "حلول احترافية لدعم نمو مشروعك وتسهيل أعمالك",
 "business.legal_title": "الخدمات القانونية",
 "business.legal_desc":
 "نقدم استشارات قانونية شاملة تشمل تأسيس الشركات، صياغة العقود، والتمثيل القانوني لحماية مصالح عملك.",
 "business.legal_f1": "تأسيس الشركات والمؤسسات",
 "business.legal_f2": "صياغة ومراجعة العقود",
 "business.legal_f3": "الاستشارات القانونية",
 "business.legal_f4": "التمثيل أمام الجهات الحكومية",
 "business.hr_title": "الموارد البشرية",
 "business.hr_desc":
 "حلول متكاملة لإدارة الموارد البشرية من التوظيف وإدارة الرواتب إلى تطوير الكفاءات وبناء فرق العمل.",
 "business.hr_f1": "التوظيف واستقطاب الكفاءات",
 "business.hr_f2": "إدارة الرواتب والمزايا",
 "business.hr_f3": "تطوير الموظفين",
 "business.hr_f4": "إدارة شؤون العاملين",
 "business.spaces_title": "حلول مساحات العمل",
 "business.spaces_desc":
 "تصميم وتجهيز مساحات العمل وفق أحدث المعايير العالمية مع حلول مرنة تتكيف مع نمو أعمالك.",
 "business.spaces_f1": "تصميم وتجهيز المكاتب",
 "business.spaces_f2": "حلول مرنة للتوسع",
 "business.spaces_f3": "إدارة المرافق",
 "business.spaces_f4": "خدمات الدعم التقني",

 // Pod page
 "pod.eyebrow": "البود الذكي",
 "pod.title": "مساحتك الخاصة للتركيز والإنتاجية",
 "pod.subtitle":
 "كبائن عمل ذكية معزولة صوتياً ومجهزة بأحدث التقنيات. مثالية للمكالمات المهمة، الاجتماعات الافتراضية، والعمل الذي يتطلب تركيزاً عالياً.",
 "pod.cta_book": "احجز بودك الآن",
 "pod.features_title": "مميزات البود الذكي",
 "pod.features_subtitle": "تصميم متقدم يجمع بين التقنية والراحة",
 "pod.feat1_title": "عزل صوتي متقدم",
 "pod.feat1_desc": "تقنية عزل صوتي احترافية توفر بيئة هادئة تماماً",
 "pod.feat2_title": "تركيز أعلى",
 "pod.feat2_desc": "بيئة مصممة خصيصاً لرفع الإنتاجية والتركيز",
 "pod.feat3_title": "خصوصية تامة",
 "pod.feat3_desc": "مساحة شخصية مغلقة لمكالماتك واجتماعاتك المهمة",
 "pod.feat4_title": "إنترنت فائق السرعة",
 "pod.feat4_desc": "اتصال مستقر وسريع لضمان سلاسة عملك",
 "pod.feat5_title": "تهوية ذكية",
 "pod.feat5_desc": "نظام تهوية متطور يضمن راحتك طوال الوقت",
 "pod.feat6_title": "شحن وتقنية",
 "pod.feat6_desc": "منافذ شحن متعددة وشاشة عرض مدمجة",
 "pod.cta_section_title": "جرّب البود الذكي اليوم",
 "pod.cta_section_subtitle":
 "احصل على تجربة عمل فريدة في بيئة معزولة ومجهزة بالكامل",

 // About
 "about.subtitle": "رائدون في توفير مساحات العمل المشتركة في الرياض",
 "about.who_we_are": "من نحن",
 "about.values_subtitle": "المبادئ التي نؤمن بها ونعمل وفقها",

 // Contact
 "contact.info_title": "معلومات التواصل",
 "contact.whatsapp_title": "تواصل عبر واتساب",
 "contact.whatsapp_subtitle": "رد سريع خلال دقائق",
 "whatsapp.float.label": "تواصل معنا",
 "contact.follow_us": "تابعنا",
 "contact.fill_required": "يرجى تعبئة جميع الحقول المطلوبة",
 "contact.placeholder_name": "أدخل اسمك",
 "contact.placeholder_email": "email@example.com",
 "contact.placeholder_message": "اكتب رسالتك هنا...",
 "contact.placeholder_service": "اختر الخدمة",
 "contact.service.spaces": "المساحات",
 "contact.service.private_office": "مكتب خاص",
 "contact.service.meeting_room": "قاعة اجتماعات",
 "contact.service.business_services": "خدمات الأعمال",
 "contact.service.pod": "البود الذكي",
 "contact.service.other": "أخرى",
 "contact.success_default": "تم إرسال طلبك بنجاح! سنتواصل معك قريباً",
 },
 en: {
 // Navbar
 "nav.home": "Home",
 "nav.services": "Services",
 "nav.spaces": "Spaces",
 "nav.business": "Business Services",
 "nav.pod": "Smart Pod",
 "nav.about": "About",
 "nav.contact": "Contact",
 "nav.cta": "Book your free tour",
 "lang.toggle.aria": "Toggle language",
 "lang.short": "AR",

 // HomePage extras
 "home.discover_more": "Discover more",
 "home.gallery_image_alt": "Workspace",
 "home.bg.about": "About us",
 "home.bg.services": "Services",
 "home.bg.why": "Why KUN",
 "home.bg.audience": "Clients",
 "home.bg.gallery": "Spaces",
 "home.bg.contact": "Contact us",

 // Footer
 "footer.quick_links": "Quick Links",
 "footer.contact_us": "Contact us",
 "footer.location": "Riyadh, Saudi Arabia",
 "footer.brand_description":
 "Leaders in coworking spaces in Riyadh. We provide a professional, collaborative environment to help you achieve your goals.",
 "footer.rights": "© KUN - All rights reserved",

 // Generic
 "common.discover_more": "Discover more",
 "common.contact_us": "Contact us",
 "common.book_now": "Book now",
 "common.send": "Send",
 "common.sending": "Sending...",
 "common.loading": "Loading...",
 "common.persons": "people",
 "common.selected": "Selected",
 "common.try_again": "Something went wrong, please try again",

 // Spaces page
 "spaces.shared_desks_title": "Shared Desks",
 "spaces.private_offices_title": "Private Offices",
 "spaces.meeting_rooms_title": "Meeting Rooms",
 "spaces.available_seats": "Available seats",
 "spaces.occupied_seats": "Occupied seats",
 "spaces.shared_desks_alt": "Shared desks",
 "spaces.book_shared_desk": "Book your shared desk",
 "spaces.book_office_btn": "Book this office",
 "spaces.book_meeting_btn": "Book meeting room",
 "spaces.reserved_label": "Reserved",
 "spaces.available_now": "Available now",
 "spaces.reserved_until": "Reserved until",
 "spaces.price_start_badge": "From",
 "spaces.price_per_month": "/ month",
 "spaces.price_currency": "SAR",
 "spaces.shared_desks_price": "1,500",
 "spaces.private_offices_price": "3,500",
 "spaces.what_you_get_eyebrow": "What you get",
 "spaces.what_you_get_title": "Everything you need for unlimited productivity",
 "spaces.shared_feat_1": "Shared desk (Hot Desk)",
 "spaces.shared_feat_2": "Unlimited high-speed internet",
 "spaces.shared_feat_3": "Unlimited refreshments (coffee, tea, water)",
 "spaces.shared_feat_4": "Unlimited printing",
 "spaces.shared_feat_5": "Flexible hourly or daily access",
 "spaces.shared_feat_6": "Use of common areas",
 "spaces.private_feat_1": "Fully equipped private office",
 "spaces.private_feat_2": "Unlimited high-speed internet",
 "spaces.private_feat_3": "Unlimited refreshments (coffee, tea, water)",
 "spaces.private_feat_4": "Unlimited printing",
 "spaces.private_feat_5": "Official business address",
 "spaces.private_feat_6": "Reception & secretarial service",
 "spaces.private_feat_7": "Meeting rooms (monthly hours)",
 "spaces.private_feat_8": "Full administrative & operational support",
 "spaces.pick_date_time": "Pick date & time",
 "spaces.available_times": "Available times",
 "spaces.empty_state": "Pick a meeting room to get started",
 "spaces.slot_booked": "Booked",
 "spaces.slot_blocked": "Blocked",
 "spaces.gallery_count": "photos",
 "spaces.gallery_open_aria": "View all photos",
 "spaces.gallery_prev_aria": "Previous",
 "spaces.gallery_next_aria": "Next",
 "spaces.gallery_dialog_desc": "Gallery for",
 "spaces.eyebrow": "Spaces",
 "spaces.title": "Workspaces that match your ambition",
 "spaces.subtitle": "Pick the perfect space for your business from a range of flexible options",

 // Booking dialog
 "book.dialog_title": "Booking request",
 "book.dialog_description": "Fill in your details and we'll be in touch shortly",
 "book.full_name": "Full name",
 "book.phone": "Phone number",
 "book.email": "Email",
 "book.helper": "We'll contact you to confirm the booking",
 "book.submit": "Send request",
 "book.fill_all_fields": "Please fill in all fields",

 // Business page
 "business.eyebrow": "Business Services",
 "business.title": "Integrated business services",
 "business.subtitle": "Professional solutions to support your growth and simplify operations",
 "business.legal_title": "Legal Services",
 "business.legal_desc":
 "Comprehensive legal counsel including company formation, contract drafting and legal representation to protect your business interests.",
 "business.legal_f1": "Company & entity formation",
 "business.legal_f2": "Contract drafting & review",
 "business.legal_f3": "Legal consulting",
 "business.legal_f4": "Government representation",
 "business.hr_title": "Human Resources",
 "business.hr_desc":
 "End-to-end HR solutions, from talent acquisition and payroll to people development and team building.",
 "business.hr_f1": "Recruitment & talent acquisition",
 "business.hr_f2": "Payroll & benefits administration",
 "business.hr_f3": "Employee development",
 "business.hr_f4": "Personnel affairs management",
 "business.spaces_title": "Workspace solutions",
 "business.spaces_desc":
 "Designing and equipping workspaces to the highest international standards with flexible solutions that scale with you.",
 "business.spaces_f1": "Office design & fit-out",
 "business.spaces_f2": "Flexible expansion solutions",
 "business.spaces_f3": "Facilities management",
 "business.spaces_f4": "Technical support services",

 // Pod page
 "pod.eyebrow": "Smart Pod",
 "pod.title": "Your private space for focus & productivity",
 "pod.subtitle":
 "Smart, soundproofed work pods equipped with the latest tech ideal for important calls, virtual meetings and deep-focus work.",
 "pod.cta_book": "Book your pod now",
 "pod.features_title": "Smart Pod features",
 "pod.features_subtitle": "Advanced design that pairs technology with comfort",
 "pod.feat1_title": "Advanced soundproofing",
 "pod.feat1_desc": "Professional acoustic insulation for a fully quiet environment",
 "pod.feat2_title": "Higher focus",
 "pod.feat2_desc": "An environment designed to lift productivity and concentration",
 "pod.feat3_title": "Total privacy",
 "pod.feat3_desc": "A closed personal space for your important calls and meetings",
 "pod.feat4_title": "High-speed internet",
 "pod.feat4_desc": "A stable, fast connection for smooth workflows",
 "pod.feat5_title": "Smart ventilation",
 "pod.feat5_desc": "Advanced ventilation that keeps you comfortable throughout the day",
 "pod.feat6_title": "Power & tech",
 "pod.feat6_desc": "Multiple power outlets and a built-in display",
 "pod.cta_section_title": "Try the Smart Pod today",
 "pod.cta_section_subtitle":
 "Get a unique work experience in a fully isolated, fully equipped pod",

 // About
 "about.subtitle": "Leaders in coworking spaces in Riyadh",
 "about.who_we_are": "Who we are",
 "about.values_subtitle": "The principles we believe in and work by",

 // Contact
 "contact.info_title": "Contact information",
 "contact.whatsapp_title": "Chat on WhatsApp",
 "contact.whatsapp_subtitle": "Quick replies within minutes",
 "whatsapp.float.label": "Contact us",
 "contact.follow_us": "Follow us",
 "contact.fill_required": "Please fill in all required fields",
 "contact.placeholder_name": "Enter your name",
 "contact.placeholder_email": "email@example.com",
 "contact.placeholder_message": "Type your message here...",
 "contact.placeholder_service": "Choose a service",
 "contact.service.spaces": "Spaces",
 "contact.service.private_office": "Private office",
 "contact.service.meeting_room": "Meeting room",
 "contact.service.business_services": "Business services",
 "contact.service.pod": "Smart Pod",
 "contact.service.other": "Other",
 "contact.success_default": "Your request was sent successfully! We'll get in touch shortly",
 },
};
